import type { RefObject } from "react"
import type { TrueSheet } from "../shims/react-native-true-sheet"

export type { AccountBottomSheetInnerContentProps } from "./AccountBottomSheetInnerContent"
export { AccountBottomSheetInnerContent } from "./AccountBottomSheetInnerContent"

type Props = {
  accountSheetRef: RefObject<TrueSheet | null>
  handleAccountSelect: (accountId: string) => void
  selectedAccountId?: string
  onClose: () => void
}

/** Native sheet is not used on web; payment flow uses `Modal` elsewhere. */
export function AccountBottomSheetContent(_props: Props) {
  return null
}
